var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M19.167 14.706H8.944L7.167 7.647H20.5zm-8.445 3.97c0 .732-.596 1.324-1.333 1.324a1.33 1.33 0 0 1-1.333-1.324c0-.731.596-1.323 1.333-1.323s1.333.592 1.333 1.323m8.89 0c0 .732-.597 1.324-1.334 1.324a1.33 1.33 0 0 1-1.334-1.324c0-.731.597-1.323 1.334-1.323s1.333.592 1.333 1.323M7.166 7.647 6.277 5H4.5"
})));
export default SvgBag;